import { BrowserRouter as Router, Route, Routes, NavLink, useNavigate, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';

const homeUrl = process.env.REACT_APP_HOME_URL;
const apiUrl = process.env.REACT_APP_API_URL;
const adminUrl = process.env.REACT_APP_ADMIN_URL;

const Blogs = () => {
const [viewMode, setViewMode] = useState("grid");
const [blogs, setBlogs] = useState([]);
const [loading, setLoading] = useState(true);
const [page, setPage] = useState(1);  
const [totalPages, setTotalPages] = useState(1); 

useEffect(() => {
	const fetchBlogs = async () => {
		try {
			const response = await fetch(`${adminUrl}/api/blogs?page=${page}`);
			const data = await response.json();    
			setBlogs(data.data);
			setTotalPages(data.last_page);
			setLoading(false);
		} catch (err) {
			console.error('Error fetching RSS feed:', err);
		}
	};

	fetchBlogs();
	window.scrollTo({ top: 0, behavior: "smooth" });
}, [page]);

const handlePageChange = (direction) => {
  setPage((prev) => {
    if (direction === "prev") return Math.max(prev - 1, 1);
    if (direction === "next") return Math.min(prev + 1, totalPages);
    return prev;
  });
};

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
};

return (
	<div className="blog_wrapper">		
		<div className="news_mainsec blog_page">
			<div className="otherpage_banner" style={{ backgroundImage: `url(${homeUrl}/assets/img/blog-bannerimg.jpg)`,}}>
				<div className="container">
					<div className="row">
						<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<div className="toptitlebox">
								<div className="breadcrumb_mainsec">
									<ul>
										<li><a href="#">Home</a></li>
										<li><span>Blog</span></li>
									</ul>
								</div>
								
								<div className="titlesec">
									<h2>Blogs</h2>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="blog_mainsec">
				<div className="container">
					<div className="row">
						<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<div className="toptitlebox">
								<div className="titlesec">
									<h2>Latest Crypto Blogs</h2>
									<p>Stay updated with breaking news and market-moving events</p>
								</div>
								
								<div className="view-toggle">
									<button onClick={() => setViewMode("grid")} className={viewMode === "grid" ? "active" : ""}>
										<i className="fas fa-border-all"></i>
									</button>
									
									<button onClick={() => setViewMode("list")} className={viewMode === "list" ? "active" : ""}>
										<i className="fas fa-list"></i>
									</button>
								</div>
							</div>
						</div>
					</div>
					
					<div className="row">
						<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<div className="articals_mainsec">
								{blogs.map((item, index) => (
								<div className={`articals_mainbox ${viewMode}`}>
									<div className="articals_innerbox">
										<div className="articals_imgbox">
											<a href={`${homeUrl}blog/${item.slug}`}><img src={`${adminUrl}/public/storage/${item.image}`} alt={item.title} /></a>
										</div>
										
										<div className="articals_contntbox">
											<div className="artical_contnt">
												<h3><a href={`${homeUrl}blog/${item.slug}`}>{item.title}</a></h3>
												<p className="article_description">{item.excerpt}</p>
											</div>
											
											<div className="share_social_sec">
												<span className="titletxt">Share:</span>
												<ul>
													<li>
														<a
														  href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(`${homeUrl}artical/${item.title}`)}`}
														  target="_blank"
														  rel="noopener noreferrer"
														><i className="fab fa-facebook-f"></i>
													</a>
													</li>
													<li>
														<a
														  href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(`${homeUrl}artical/${item.title}`)}`}
														  target="_blank"
														  rel="noopener noreferrer"
														><i className="fab fa-linkedin-in"></i>
														</a>
													</li>
													<li>
														<a
														  href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(`${homeUrl}artical/${item.title}`)}&text=${encodeURIComponent(item.title)}`}
														  target="_blank"
														  rel="noopener noreferrer"
														><i className="fab fa-twitter"></i>
														</a>
													</li>
													<li>
														<a
														  href={`https://t.me/share/url?url=${encodeURIComponent(`${homeUrl}artical/${item.title}`)}&text=${encodeURIComponent(item.title)}`}
														  target="_blank"
														  rel="noopener noreferrer"
														><i class="fab fa-telegram-plane"></i>
														</a>
													</li>
												</ul>
											</div>
											
											<div className="artical_info">
												<div className="datetimebox">
													<span className="datetime">
														<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-calendar h-3 w-3"><path d="M8 2v4"></path><path d="M16 2v4"></path><rect width="18" height="18" x="3" y="4" rx="2"></rect><path d="M3 10h18"></path></svg>
														
														<span className="datetxt">{formatDate(item.created_at)}</span>
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>
								))}
							</div>
							<div className="btn_mainsec pagination mt-4">
							  <button onClick={() => handlePageChange("prev")} disabled={page === 1} className="btn_style">Prev</button>
							  <button onClick={() => handlePageChange("next")} disabled={page === totalPages} className="btn_style">Next</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		{loading && (
		<div className="loader_mainbox">
			<div className="loader_mainsec">
				<div className="loader market-spinner">
					<svg class="icon" viewBox="0 0 24 24" width="20" height="20" aria-label="Loading market data">
					<polyline points="22 7 13.5 15.5 8.5 10.5 2 17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					<polyline points="16 7 22 7 22 13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
				</div>
					 
				<div className="text-loader">
					<span>C</span>
					<span>O</span>
					<span>I</span>
					<span>N</span>
					<span>V</span>
					<span>I</span>
					<span>E</span>
					<span>W</span>
					<span>S</span>
				</div>
			</div>
		</div>
		)}
	</div>
);
};

export default Blogs;